export const JOBS_AREAS = [
  "Supervisor",
  "Associate",
  "Executive",
  "Liaison",
  "Officer",
  "Manager",
  "Engineer",
  "Specialist",
  "Director",
  "Coordinator",
  "Administrator",
  "Architect",
  "Analyst",
  "Designer",
  "Planner",
  "Orchestrator",
  "Technician",
  "Developer",
  "Producer",
  "Consultant",
  "Assistant",
  "Facilitator",
  "Agent",
  "Representative",
  "Strategist",
];

export const JOB_LEVELS = [
  "Lead",
  "Senior",
  "Direct",
  "Corporate",
  "Dynamic",
  "Future",
  "Product",
  "National",
  "Regional",
  "District",
  "Central",
  "Global",
  "Customer",
  "Investor",
  "Dynamic",
  "International",
  "Legacy",
  "Forward",
  "Internal",
  "Human",
  "Chief",
  "Principal",
];
